import {
  Component,
  Input,
  input,
  ChangeDetectionStrategy,
} from '@angular/core';
import { Action } from '../enums/action.enum';
import { DeviceComponent } from './device.component';
import {
  ValidationMessageEntry,
  ValidationParamEntry,
} from '../type-helpers/validation-msg';

@Component({
  template: '',
  changeDetection: ChangeDetectionStrategy.Eager,
  standalone: false,
})
export class BaseComponent extends DeviceComponent {
  readonly screenName = input<string>();

  validationMessages = input<Record<string, ValidationMessageEntry>>();
  validationParams = input<Partial<Record<string, ValidationParamEntry>>>();
}
